import React from 'react'
import { t } from 'src/translations'
import { SegmentedOfferState } from 'public/components/online_ordering/segmentedOfferUtils'

export const EligibilityBadge = ({
  segmentState
}: {
  segmentState: SegmentedOfferState
}) => {
  if (segmentState === 'ineligible') {
    return <span className='notEligibleBadge'>{t('offers.not-eligible')}</span>
  }
  if (segmentState === 'eligible') {
    return <span className='eligibleBadge'>{t('offers.eligible')}</span>
  }
  return null
}
